import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import GpDashboard from "./pages/GpDashboard";
import DistrictDashboard from "./pages/DistrictDashboard";
import BlockDashboard from "./pages/BlockDashboard";

import PrivateRoute from "./PrivateRoute";
import CreateUser from "./pages/CreateUser";
import Teams from "./pages/Teams";
import PaymentManagement from "./pages/PaymentManagement";
import SetPassword from "./pages/SetPassword";
import Profile from "./pages/Profile";
import BeneficiaryManagement from "./pages/BeneficiaryManagement";
import BeneficiaryProfile from "./pages/BeneficiaryProfile";
import VerifyCard from "./pages/VerifyCard";
import StateDashboard from "./pages/StateDashboard";

function Unauthorized() {
  return <h2>Access Denied</h2>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        <Route path="/dashboard" element={<PrivateRoute role="ADMIN"><Dashboard /></PrivateRoute>} />
        <Route path="/gp-dashboard" element={<PrivateRoute role="GP_COORDINATOR"><GpDashboard /></PrivateRoute>} />
        <Route path="/district-dashboard" element={<PrivateRoute role="DISTRICT_COORDINATOR"><DistrictDashboard /></PrivateRoute>} />
        <Route path="/block-dashboard" element={<PrivateRoute role="BLOCK_COORDINATOR"><BlockDashboard /></PrivateRoute>} />
   <Route path="/state-dashboard" element={<PrivateRoute role="STATE_COORDINATOR"><StateDashboard /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/teams" element={<PrivateRoute><Teams /></PrivateRoute>} />
        <Route path="/payments" element={<PrivateRoute><PaymentManagement /></PrivateRoute>} />
        <Route path="/createuser" element={<PrivateRoute><CreateUser /></PrivateRoute>} />
        <Route path="/beneficiaries" element={<PrivateRoute><BeneficiaryManagement /></PrivateRoute>} />
        <Route path="/beneficiary/:id" element={<PrivateRoute><BeneficiaryProfile /></PrivateRoute>} />
<Route path="/verify-card/:beneficiaryId" element={<VerifyCard />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;